import {Entity} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {SelectableEntityType} from "../EntityTypeSelect/EntityTypeSelect";
import {SiteSelect} from "../SiteSelect/SiteSelect";
import {WellSelect} from "../WellSelect/WellSelect";
import {ContainerSelect} from "../ContainerSelect/ContainerSelect";
import {MeterSelect} from "../MeterSelect/MeterSelect";
import {BaseEntitySelectProps} from "../base-entity-select";
import {PipelineSelect} from "../PipelineSelect/PipelineSelect";
import {RouteSelect} from "../RouteSelect/RouteSelect";
import {OperatingAreaSelect} from "../OperatingAreaSelect/OperatingAreaSelect";
import {ContainerClusterSelect} from "../ContainerClusterSelect/ContainerClusterSelect";
import {CompanySelect} from "../CompanySelect/CompanySelect";

export type MyEntitySelectProps = Omit<BaseEntitySelectProps<Entity>, "entities" | "loading"> & {
  regionId?: string
  entityType?: SelectableEntityType | string
}

export const EntitySelect = (props: MyEntitySelectProps) => {
  const {regionId, entityType, ...rest} = props

  return useMemo(() => {
    if (entityType === 'COMPANY') {
      return <CompanySelect {...rest} selector={{regionId}}/>;
    } else if (entityType === 'SITE') {
      return <SiteSelect {...rest} selector={{regionId}}/>;
    } else if (entityType === 'WELL') {
      return <WellSelect {...rest} selector={{regionId}}/>;
    } else if (entityType === 'CONCOMMIGLED') {
      return <ContainerClusterSelect {...rest} selector={{regionId}}/>;
    } else if (entityType === 'CONTAINER') {
      return <ContainerSelect {...rest} selector={{regionId}}/>;
    } else if (entityType === 'METER') {
      return <MeterSelect {...rest} selector={{regionId}}/>;
    } else if (entityType === 'PIPE') {
      return <PipelineSelect {...rest} selector={{regionId}}/>;
    } else if (entityType === 'ROUTE') {
      return <RouteSelect {...rest} selector={{regionId}}/>;
    } else if (entityType === 'OPERATINGAREA') {
      return <OperatingAreaSelect {...rest} selector={{regionId}}/>;
    } else {
      return <div/>
    }
  }, [regionId, entityType, rest])
}
